<div cdkTrapFocus class="request-confirm-modal">
  <h3 class="for-desktop">{{ hasError ? 'Request Failed' : 'Request Sent' }}</h3>
  <img src="assets/images/request_sent.svg" alt="Request sent logo" />
  <p class="text-m" *ngIf="hasError">{{ failureMessage }}</p>
  <p class="text-m" *ngIf="!hasError">{{ successMessage }}</p>
  <button autofocused id="close-request-modal" class="hch-btn hch-btn-secondary close-footer" (click)="bsModalRef.hide()">Close</button>
</div>
